export enum CheckoutVariants {
  default = 'default',
  kiosk = 'kiosk',
  isolatedCheckout = 'isolatedCheckout',
}
